import React, { ReactElement } from "react";

import { Heading, Wrapper } from "./FormResultItem.styled";
import FormResultItemProps from "./FormResultItemProps";

import { addEditAttributes } from "../../utils/episerver";
import { StyledTextBlock } from "../FormInfo/FormInfoBox.styled";

const FormResultItem = ({
    heading,
    mainBody,
}: FormResultItemProps): ReactElement => {
    return (
        <Wrapper>
            <Heading>{heading}</Heading>
            {mainBody && (
                <StyledTextBlock
                    content={mainBody}
                    areaName="mainBody"
                    {...addEditAttributes("MainBody")}
                />
            )}
        </Wrapper>
    );
};

export default React.memo(FormResultItem);
